/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component';
const styles_DataTableRowWrapperComponent:any[] = ([] as any[]);
export const RenderType_DataTableRowWrapperComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableRowWrapperComponent,data:{}});
function View_DataTableRowWrapperComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(null as any));
}
function View_DataTableRowWrapperComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_DataTableRowWrapperComponent_3)),i0.ɵdid(540672,(null as any),0,i1.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutletContext:[0,'ngTemplateOutletContext'],
          ngTemplateOutlet:[1,'ngTemplateOutlet']},(null as any)),(_l()(),i0.ɵand(0,
      (null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.groupContext;
    const currVal_1:any = _co.groupHeader.template;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_DataTableRowWrapperComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),5,'div',[['class',
      'datatable-group-header']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i0.ɵdid(278528,(null as any),0,i1.NgStyle,[i0.KeyValueDiffers,
      i0.ElementRef,i0.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),(_l()(),i0.ɵted((null as any),
      ['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_DataTableRowWrapperComponent_2)),i0.ɵdid(16384,(null as any),0,i1.NgIf,
      [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
      i0.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getGroupHeaderStyle();
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.groupHeader && _co.groupHeader.template);
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
function View_DataTableRowWrapperComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0),(_l()(),i0.ɵand(0,(null as any),(null as any),
      0))],(null as any),(null as any));
}
function View_DataTableRowWrapperComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(null as any));
}
function View_DataTableRowWrapperComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_DataTableRowWrapperComponent_7)),i0.ɵdid(540672,(null as any),0,i1.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutletContext:[0,'ngTemplateOutletContext'],
          ngTemplateOutlet:[1,'ngTemplateOutlet']},(null as any)),(_l()(),i0.ɵand(0,
      (null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.rowContext;
    const currVal_1:any = _co.rowDetail.template;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_DataTableRowWrapperComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'datatable-row-detail']],[[4,'height','px']],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableRowWrapperComponent_6)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_1:any = (_co.rowDetail && _co.rowDetail.template);
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.detailRowHeight;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_DataTableRowWrapperComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableRowWrapperComponent_1)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableRowWrapperComponent_4)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableRowWrapperComponent_5)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.DataTableRowWrapperComponent = _v.component;
    const currVal_0:any = (_co.groupHeader && _co.groupHeader.template);
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = (((_co.groupHeader && _co.groupHeader.template) && _co.expanded) || (!_co.groupHeader || !_co.groupHeader.template));
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = ((_co.rowDetail && _co.rowDetail.template) && _co.expanded);
    _ck(_v,8,0,currVal_2);
  },(null as any));
}
export function View_DataTableRowWrapperComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-row-wrapper',
      [['class','datatable-row-wrapper']],(null as any),[[(null as any),'contextmenu']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('contextmenu' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onContextmenu($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DataTableRowWrapperComponent_0,RenderType_DataTableRowWrapperComponent)),
      i0.ɵdid(311296,(null as any),0,i2.DataTableRowWrapperComponent,[i0.ChangeDetectorRef,
          i0.KeyValueDiffers],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const DataTableRowWrapperComponentNgFactory:i0.ComponentFactory<i2.DataTableRowWrapperComponent> = i0.ɵccf('datatable-row-wrapper',
    i2.DataTableRowWrapperComponent,View_DataTableRowWrapperComponent_Host_0,{innerWidth:'innerWidth',
        rowDetail:'rowDetail',groupHeader:'groupHeader',offsetX:'offsetX',detailRowHeight:'detailRowHeight',
        row:'row',groupedRows:'groupedRows',rowIndex:'rowIndex',expanded:'expanded'},
    {rowContextmenu:'rowContextmenu'},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/node_modules/@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component.ngfactory.ts